export default __webpack_public_path__ + "static/media/walletconnect-logo.82d414a7.svg";